module.exports = __webpack_public_path__ + "blog_2.jpg?b1c16738b1e5975e9c9c4620ac2f88ef";